import api from './api';
import { ApiResponse } from '../types';

export interface WorkCategoryItem {
  name: string;
  percentage: number;
}

export interface ProjectMonitoringItem {
  id: number;
  name: string;
  workCode: string | null;
  buildingType: string | null;
  projectStatus: string | null;
  client: string | null;
  city: string | null;
  country: string | null;
  currency: string;
  createdAt: string;

  // Cronograma
  startDate: string | null;
  endDate: string | null;
  totalDays: number;
  daysElapsed: number;
  daysRemaining: number;
  timeProgressPct: number;
  overdue: boolean;

  // Presupuesto
  budget: number;
  totalEstimatedCost: number;
  actualCost: number;
  totalM2: number;
  costPerM2: number;
  budgetUsedPct: number;
  budgetVariance: number;
  budgetExceeded: boolean;
  totalPOCommitted: number;

  // Unidades Funcionales
  totalFU: number;
  soldFU: number;
  availableFU: number;
  soldFUPct: number;

  // Rubros
  workCategories: WorkCategoryItem[];

  // Órdenes de Compra
  totalPO: number;
  draftPO: number;
  sentPO: number;
  receivedPO: number;
  cancelledPO: number;
  totalPOAmount: number;

  // Facturas
  totalInvoices: number;
  pendingInvoices: number;
  partiallyPaidInvoices: number;
  paidInvoices: number;
  totalInvoicesAmount: number;
  pendingInvoicesAmount: number;

  // Ventas
  totalSales: number;
  totalSalesAmount: number;

  // Alertas
  alerts: string[];
}

export interface ProjectMonitoringDTO {
  projects: ProjectMonitoringItem[];
}

const projectMonitoringService = {
  async getMonitoring(): Promise<ProjectMonitoringDTO> {
    const res = await api.get<ApiResponse<ProjectMonitoringDTO>>('/project-monitoring');
    return res.data.data;
  },
};

export default projectMonitoringService;
